import { NgModule } from "@angular/core";
import { SignInComponent } from "./signin/signin.component";
import { MatButtonModule } from "@angular/material/button";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Route, Router, RouterModule } from "@angular/router";
import { SignoutComponent } from "./signout/signout.component";
import { ProfileComponent } from "./profile/profile.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";

const routes = <Route[]>[
    {
        path: 'signin',
        component: SignInComponent,
    },
    {
        path: 'signout',
        component: SignoutComponent
    },
    {
        path: 'profile',
        component: ProfileComponent
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent
    }
];

@NgModule({
    declarations: [
        SignInComponent,
        SignoutComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forChild(routes),
        MatButtonModule
    ],
    exports: [RouterModule]
})
export class IdentityModule {

}